export default "__VITE_ASSET__DJTkkF5A__"